"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var services_1 = require("../../services");
var constants_1 = require("../../constants");
var ModalDescriptionComponent = (function () {
    function ModalDescriptionComponent(router, activatedRoute, changeDetectorRef, localizationService, packLevelService, progressService, eventService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.changeDetectorRef = changeDetectorRef;
        this.localizationService = localizationService;
        this.packLevelService = packLevelService;
        this.progressService = progressService;
        this.eventService = eventService;
        this.urlPartPath = constants_1.RETINA ? '2x/retina_' : '1x/';
        this.isImageHide = true;
        this.stateActiveModalDescription = true;
        this.rootLevelUrl = this.localizationService.getRootUrlForLevel();
    }
    ModalDescriptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeOnEvents();
        this.renderLevelInfos();
        this.renderInterfaceLocals();
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            _this.imageUrl = '';
            _this.isImageHide = true;
            _this.changeDetectorRef.detectChanges();
            _this.levelId = params.levelId;
            _this.levelId = _this.packLevelService.levelIdsByNumbers[parseFloat(_this.levelId)] || _this.levelId;
            _this.level = _this.packLevelService.levels[_this.levelId];
            if (!_this.level) {
                _this.router.navigate([_this.rootLevelUrl]);
                return;
            }
            _this.goalLineMoves = _this.level.goalLineMoves;
            _this.goalElementaryMoves = _this.level.goalElementaryMoves;
            _this.setFoundVariants();
            _this.imageUrl = require("../../assets/images/png/levels/" + (_this.urlPartPath + _this.levelId) + "Detailed.png");
            _this.tutorial = _this.level.tutorial;
            _this.packNumber = _this.level.packNumber;
            _this.levelNumber = _this.level.levelNumber;
            if (_this.progressService.isLevelPlayed(_this.levelId)) {
                _this.hideModal();
            }
            else {
                _this.showModal();
            }
            _this.isImageHide = false;
        });
    };
    ModalDescriptionComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalDescriptionComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionHideModalsEvent
            = this.eventService.subscribe('hideModals', function () { return _this.hideModal(); });
        this.subscriptionShowModalDescriptionEvent
            = this.eventService.subscribe('showModalDescription', function () { return _this.showModal(); });
    };
    ModalDescriptionComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionHideModalsEvent.unsubscribe();
        this.subscriptionShowModalDescriptionEvent.unsubscribe();
    };
    ModalDescriptionComponent.prototype.showModalHelp = function () {
        this.eventService.fire('showModalHelp');
    };
    ModalDescriptionComponent.prototype.showModal = function () {
        this.setFoundVariants();
        this.stateActiveModalDescription = true;
    };
    ModalDescriptionComponent.prototype.hideModal = function () {
        this.stateActiveModalDescription = false;
        this.eventService.fire('hintChecker');
    };
    ModalDescriptionComponent.prototype.setFoundVariants = function () {
        this.foundVariantsCount = this.progressService.levelsResults[this.levelId] ? this.progressService.levelsResults[this.levelId].v_count : 0;
    };
    ModalDescriptionComponent.prototype.renderLevelInfos = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (levels) {
            _this.levelLocals = levels;
        });
    };
    ModalDescriptionComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
        });
    };
    return ModalDescriptionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ModalDescriptionComponent.prototype, "starsResult", void 0);
ModalDescriptionComponent = __decorate([
    core_1.Component({
        selector: 'modal-description-component',
        template: require('./modal-description.component.pug'),
        styles: [require('./modal-description.component.scss')]
    }),
    __metadata("design:paramtypes", [router_1.Router,
        router_1.ActivatedRoute,
        core_1.ChangeDetectorRef,
        services_1.LocalizationService,
        services_1.PackLevelService,
        services_1.ProgressService,
        services_1.EventService])
], ModalDescriptionComponent);
exports.ModalDescriptionComponent = ModalDescriptionComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/modal-description/modal-description.component.ts
// module id = 245
// module chunks = 0